import { Badge, Flex, Typography } from '@aloft/toolkit-sui';

import { BulkAnalysisFormSubmit } from './BulkAnalysisForm.tsx';
import { GEMINI_MODELS } from './imageAnalysisFormConfig.ts';

type Props = {
  formValues: BulkAnalysisFormSubmit;
  compsCount: number;
};

const formatSample = (sample: BulkAnalysisFormSubmit['sample']): string => {
  if (sample.type === 'all') return 'All images';
  if (sample.type === 'first') return `First ${sample.count} images`;
  return `Random ${sample.count} images`;
};

export const BulkRunPills = ({ formValues, compsCount }: Props) => {
  const modelLabel =
    GEMINI_MODELS.find((m) => m.id === formValues.model)?.label ?? formValues.model;

  const pills: string[] = [
    modelLabel,
    ...(formValues.promptOverride != null ? ['Custom prompt'] : []),
    ...(formValues.qualityFilter && formValues.qualityFilter.length > 0
      ? [
          formValues.qualityFilter
            .sort((a, b) => a - b)
            .map((n) => `Q${n}`)
            .join(', '),
        ]
      : []),
    ...(formValues.conditionFilter && formValues.conditionFilter.length > 0
      ? [
          formValues.conditionFilter
            .sort((a, b) => a - b)
            .map((n) => `C${n}`)
            .join(', '),
        ]
      : []),
    ...(formValues.stateFilter ? [formValues.stateFilter] : []),
    ...(formValues.zipFilter ? [formValues.zipFilter] : []),
    formatSample(formValues.sample),
    `${compsCount} comp${compsCount !== 1 ? 's' : ''}`,
  ];

  return (
    <Flex gap="8px" flexWrap="wrap" alignItems="center">
      <Typography variant="body2" color="textSecondary">
        Run:
      </Typography>
      {pills.map((text) => (
        <Badge key={text} text={text} variant="primary" size="sm" />
      ))}
    </Flex>
  );
};
